export default class DeleteShopUser extends HTMLAnchorElement{
    constructor() {
        super();
    }

    connectedCallback() {
        this.addUsersListener();
    }

    addUsersListener() {
        // Suppression d'une relation shop_user
        this.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            window.swal({
                title: 'Êtes-vous certain ?',
                text: "L'action sera irréversible",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, le supprimer',
                confirmButtonColor: "#D2282D",
                cancelButtonText: 'Non, annuler'
            }).then((result) => {
                if (result.value) {
                    $.ajax({
                        url:this.href,
                        method:'DELETE',
                        success:(answer) => {
                            swal(
                                '',
                                "L'utilisateur a bien été mis à jour",
                                'success'
                            );

                            $('.list-shops').html(answer.view);
                        }
                    });
                }
            });
        });
    }
}